import { Column } from "react-table";
import * as React from "react";

import { ITableProps } from "src/library/components/Tables/Table";
import * as globalTableColumns from "src/core/shared/components/TableGlobalColumns";
import { IProcessJobError } from "src/core/process-job/api/processJobs.api";
import { Button } from "src/library/components/Button";
import { Icons } from "src/library/components/Icon/types";

export type IProductImportErrorsColumns = Partial<ITableProps>;

export const productReplacementErrorsTableColumns = (): Array<Column<IProcessJobError<"global-product-replacement">>> => [
  globalTableColumns.id(),
  globalTableColumns.standardText({
    Header: "Message",
    accessor: "message",
    multiLine: true,
    width: 600,
    Cell: row => {
      const payload = row.original as IProcessJobError<"global-product-replacement">;

      if (payload.data?.replacements?.length === 1) {
        return (
          payload.message + ` (from ${payload.data.replacements[ 0 ].fromPartNumber} to ${payload.data.replacements[ 0 ].toPartNumber})`
        );
      } else {
        return payload.message;
      }
    }
  }),
  globalTableColumns.standardText({
    Header: "Order",
    accessor: "data.orderId",
    width: 150,
    sortable: false,
    filterable: false,
    Cell: row => {
      if (row.original.data.orderId) {
        return (
          <Button
            iconPosition="right"
            icon={Icons.OPENNEW}
            onClick={() => {
              window.open(`/orders/${row.original.data.orderId}`);
            }}
          >
            View order
          </Button>
        );
      } else if (row.original.data.listId) {
        return (
          <Button
            iconPosition="right"
            icon={Icons.OPENNEW}
            onClick={() => {
              window.open(`/lists/${row.original.data.listId}`);
            }}
          >
            View list
          </Button>
        );
      }

      return null;
    }
  })
];
